export const getRoutes = `
  query GetRoutes($site: [String], $type: [String], $marketId: [QueryArgument]) {
    entries(site: $site, type: $type, market: $marketId) {
      id
      slug
    }
  }
`
